<template>
  <el-dialog title="离职" :visible.sync="formVisible" width="900px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <ul class="cssNav">
        <li v-for="(item,index) in ulList" :key="index" :class="{'active': item.id === tabType}" :style="{'width':ulList.length==2?'50%':ulList.length==3?'33%':'25%'}">{{item.text}}</li>
      </ul>
      <div style="padding-left: 40px;margin-bottom: 20px;">离职需要把区域，团队，客户归属新的业务</div>
      <el-form-item label="分配方式" :prop="tabType === 3?'':'radio1'">
        <el-radio-group v-model="form.radio1" v-if="tabType === 1" @change="changeRadio1">
          <el-radio :label="1" v-if="itemRow && itemRow.customer && itemRow.customer.clevel!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
        <el-radio-group v-model="form.radio2" v-if="tabType === 2" @change="changeRadio2">
          <el-radio :label="1" v-if="itemRow && itemRow.customer && itemRow.customer.clevel!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
        <el-radio-group v-model="form.radio3" v-if="tabType === 3" @change="changeRadio3">
          <el-radio :label="1" v-if="itemRow && itemRow.customer && itemRow.customer.clevel!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="区域：" prop="connectArea" required v-if="tabType === 1 && form.radio1 === 2">
        <div v-for="(item,index) in form.connectArea" :key="index" class="full-box">
          <el-cascader v-model="item.districtCode" :props="cascaderProps" collapse-tags placeholder="请选择需要分配的区域" :options="options.businessAreOptions" clearable></el-cascader>
          <el-select v-model="item.toCustomerid" placeholder="请选择业务员" clearable size="small" filterable :filter-method="identityFilter" @blur="getBusinessList()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.name} (${it.pho})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddItem"></i>
            <i class="el-icon-minus" @click="handleDeleteItem(index)"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="团队：" prop="connectTeam" required v-if="tabType === 2 && form.radio2 === 2">
        <!-- {{form.childDetail}} -->
        <div v-for="(item,index) in form.connectTeam" :key="index" class="full-box">
          <el-select v-model="item.beCustomerid" placeholder="请选择需要分配的团队" collapse-tags multiple clearable size="small">
            <el-option v-for="(it,index) in options.teamOptions" :key="it.customer.id" :label="it.customer.name + '(' + it.customerLevel.name +')' + it.customer.pho" :value="it.customer.id"></el-option>
          </el-select>
          <el-select v-model="item.toCustomerid" placeholder="请选择业务员" clearable size="small" filterable :filter-method="identityFilter" @blur="getBusinessList()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.name} (${it.pho})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddTeam"></i>
            <i class="el-icon-minus" @click="handleDeleteTeam(index)"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="客户：" prop="connectCustomer" required v-if="tabType === 3 && form.radio3 === 2">
        <div v-for="(item,index) in form.connectCustomer" :key="index" class="full-box">
          <el-select v-model="item.beCustomerid" placeholder="请选择需要分配的客户" multiple collapse-tags clearable size="small">
            <el-option v-for="(it,index) in options.customerOptions" :key="it.customer.id" :label="it.customer.name + '(' + it.customerLevel.name +')' + it.customer.pho" :value="it.customer.id"></el-option>
          </el-select>
          <el-select v-model="item.toCustomerid" placeholder="请选择业务员" clearable size="small" filterable :filter-method="identityFilter" @blur="getBusinessList()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.name} (${it.pho})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddCustomer"></i>
            <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false,tabType=1">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">{{tabType === 3?'确认离职':'下一步'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'
import customerApi from '@/api/technical/customer'
import clientAreaApi from '@/api/client/clientArea'
import clientListApi from '@/api/client/clientList'

function initFormBean() {
  const formBean = {
    radio1: null,
    radio2: null,
    radio3: null,
    connectArea: [],
    connectTeam: [],
    connectCustomer: []
  }
  return formBean
}

function initFormBean2() {
  const formBean = [{
    id: 1,
    text: '分配区域'
  }, {
    id: 2,
    text: '分配团队'
  }, {
    id: 3,
    text: '分配客户'
  }, {
    id: 4,
    text: '确认离职'
  }]
  return formBean
}
export default {
  // props: ['identityOptions'],
  data() {
    return {
      options: {
        technicalServiceLevel: [],
        identityOptions: [],
        businessAreOptions: [],
        teamOptions: [],
        customerOptions: []

      },
      isLoading: false,
      form: initFormBean(),
      formVisible: false,
      maxLevel: null,
      id: null,
      formRules: {
        radio1: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
        radio2: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
        radio3: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
      },
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      itemRow: null,
      tabType: 1,
      ulList: initFormBean2()
    }
  },
  created() {

  },
  methods: {
    identityFilter(e) {
      this.getBusinessList(e)
    },
    // 获取业务员
    getBusinessList(e) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        // levelIdSortSign: 1,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100
      }
      // if(e){
      obj.name = e
      // }
      // if(this.tabType === 2 ){
      //   obj.maxLevel=this.maxLevel
      // }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list.filter(i => i.id != this.id)
       
      })
    },
    // 获取区域
    changeIdentity(row) {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      clientAreaApi.fetchTreeList({
        customerId: this.itemRow.customer.id,
        parentCustomerId: this.itemRow.customer.parentId,
        addOrDelete: 2,
        v: 3
      }).then(({
        data
      }) => {
        this.options.businessAreOptions = this.formatCascaderData(data)
        this.loading.close()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          // this.$set(this.form,'radio1',row.levelId == 1 ? 2 : 1)
          this.form.radio1 = row.customer.clevel == 1 ? 2 : 1
          this.form.radio2 = row.customer.clevel == 1 ? 2 : 1
          // this.form.radio3 = row.customer.clevel == 1 ? 2 : 1
          this.changeRadio1()
        })
      }).catch(() => {
        this.loading.close()
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    //指定分配 管辖区域
    changeRadio1() {
      let {
        radio1
      } = this.form;
      if (radio1 === 1) {
        this.$set(this.form, 'connectArea', [])
      } else {
        this.form.connectArea.push({
          area: [],
          toCustomerid: ''
        })
      }
    },
    handleDeleteItem(index) {
      if (this.form.connectArea <= 1) return
      this.form.connectArea.splice(index, 1)
    },
    handleAddItem() {
      this.form.connectArea.push({
        area: [],
        toCustomerid: ''
      })
    },
    //指定分配 团队
    getTeam() {
      let query = {
        parentId: this.itemRow.customer.id,
        pageNo: 1,
        pageSize: 1000,
        customerType: 2
      }
      clientListApi.fetchList2(query)
        .then(data => {
          this.options.teamOptions = data.data.list ? data.data.list : []
          if (!this.options.teamOptions.length) {
            let index = this.ulList.findIndex(i => i.id == 2)
            this.ulList.splice(index, 1)
          }
          // console.log('-----option: ', this.options.teamOptions);
        })
    },
    changeRadio2() {
      let {
        radio2
      } = this.form;
      if (radio2 === 1) {
        this.$set(this.form, 'connectTeam', [])
      } else {
        this.form.connectTeam.push({
          beCustomerid: [],
          toCustomerid: ''
        })
      }
    },
    handleDeleteTeam(index) {
      if (this.form.connectTeam <= 1) return
      this.form.connectTeam.splice(index, 1)
    },
    handleAddTeam() {
      this.form.connectTeam.push({
        beCustomerid: [],
        toCustomerid: ''
      })
    },
    //指定分配 客户
    getCustomer() {
      let query = {
        parentId: this.itemRow.customer.id,
        pageNo: 1,
        pageSize: 1000,
        customerType: 3
      }
      clientListApi.fetchList2(query)
        .then(data => {
          this.options.customerOptions = data.data.list ? data.data.list : []
          if (!this.options.customerOptions.length) {
            let index = this.ulList.findIndex(i => i.id == 3)
            this.ulList.splice(index, 1)
          }
          // console.log('-----option: ', this.options.customerOptions);
        })
    },
    changeRadio3() {
      let {
        radio3
      } = this.form;
      if (radio3 === 1) {
        this.$set(this.form, 'connectCustomer', [])
      } else {
        this.form.connectCustomer.push({
          beCustomerid: [],
          toCustomerid: ''
        })
      }
    },
    handleDeleteCustomer(index) {
      if (this.form.connectCustomer <= 1) return
      this.form.connectCustomer.splice(index, 1)
    },
    handleAddCustomer() {
      this.form.connectCustomer.push({
        beCustomerid: [],
        toCustomerid: ''
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.ulList = initFormBean2()
      this.tabType = 1
    },
    async handleQuit(row) {
      this.resetForm()
      this.itemRow = { ...row }
      this.maxLevel = row.customer.clevel
      this.id = row.customer.id
      await this.getBusinessList()
      await this.changeIdentity(row)
      await this.getTeam()
      await this.getCustomer()


    },
    calcParams() {
      let {
        radio1,
        radio2,
        radio3,
        connectArea,
        connectTeam,
        connectCustomer
      } = this.form
      let params = {
        customerid: this.itemRow.customer.id,
        connectArea: [],
        connectTeam: [],
        connectCustomer: [],
        isDeparted: 1
      }
      if (radio1 === 2) {
        let arr1 = []
        // console.log('connectArea111111: ', connectArea);
        connectArea && connectArea.forEach(item => {
          item.districtCode.map(i => {
            arr1.push({
              area: {
                provinceCode: i[0],
                cityCode: i[1],
                districtCode: i[2],
                areaType: 3,
                customerId: this.itemRow.customer.id
              },
              toCustomerid: item.toCustomerid
            })
          })
        })
        params.connectArea = arr1
      }
      if (radio2 === 2) {
        let arr2 = []
        connectTeam && connectTeam.forEach(item => {
          item.beCustomerid.map(i => {
            arr2.push({
              beCustomerid: i,
              toCustomerid: item.toCustomerid
            })
          })
        })
        params.connectTeam = arr2
      }
      if (radio3 === 2) {
        let arr3 = []
        params.connectCustomer = connectCustomer && connectCustomer.forEach(item => {
          item.beCustomerid.map(i => {
            arr3.push({
              beCustomerid: i,
              toCustomerid: item.toCustomerid
            })
          })
        })
        params.connectCustomer = arr3
      }
      if (radio1 == 1 || (radio2 == 1 && this.options.teamOptions.length) || (radio3 == 1 && this.options.customerOptions.length)) {
        params.toParentCustomerid = this.itemRow.customer.parentId
      }
      // console.log('areaList:----------- ', connectArea);
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate(async (valid) => {
        if (valid) {
          // console.log('params11: ', this.form);
          if (this.tabType == 1 && this.form.radio1 == 2) {
            let arrs = this.form.connectArea.filter(item => !item.districtCode || !item.districtCode.length || !item.toCustomerid)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          if (this.tabType == 2 && this.form.radio2 == 2) {
            let arrs = this.form.connectTeam.filter(item => !item.beCustomerid || !item.beCustomerid.length || !item.toCustomerid)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          if (this.tabType == 3 && this.form.radio3 == 2) {
            let arrs = this.form.connectCustomer.filter(item => !item.beCustomerid || !item.beCustomerid.length || !item.toCustomerid)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          let params = this.calcParams();
          params.dataCompareLogType2 = 26
          // console.log('params: ', params);
          if (this.tabType == 1 && !this.options.teamOptions.length && !this.options.customerOptions.length) {
            this.tabType = 3
          }
          if (this.tabType == 2 && !this.options.customerOptions.length) {
            this.tabType = 3
          }
          if (this.tabType === 3) {
            this.isLoading = true
            this.$common.confirm('是否确认提交离职，离职后该业务员无法享受业务权益').then(() => clientListApi.resignQuit([params]))
              .then(() => {
                this.postCallback()
              }).catch(() => {
                console.log('取消了');
                this.isLoading = false
                if (this.tabType == 3 && !this.options.teamOptions.length && !this.options.customerOptions.length) {
                  this.tabType = 1
                }
                if (this.tabType == 3 && !this.options.customerOptions.length) {
                  this.tabType = 2
                }
              });
          } else {
            // console.log('000000000000000')

            if (this.tabType == 1 && !this.options.teamOptions.length) {
              this.tabType = this.tabType + 2
            } else {
              this.tabType++
            }
            await this.getBusinessList()
            if (this.tabType == 2) {
              this.changeRadio2()
            }
            if (this.tabType == 3) {
              this.changeRadio3()
            }
          }

        }
      });
    },
    postCallback(response) {
      this.tabType = 1
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 50%;
  margin-left: 5px;
}

::v-deep .el-cascader {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
}

.cssNav {
  display: flex;
  margin: 0 0 20px;

  li {
    // padding: 0px 74px;
    line-height: 40px;
    background: #eff8fd;
    display: inline-block;
    color: #1596cd;
    position: relative;
    display: flex;
    justify-content: center;

    &::after {
      content: '';
      display: block;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #eff8fd;
      position: absolute;
      right: -20px;
      top: 0;
      z-index: 10;
    }

    &::before {
      content: '';
      display: block;
      border-top: 20px solid #eff8fd;
      border-bottom: 20px solid #eff8fd;
      border-left: 20px solid #eff8fd;
      position: absolute;
      left: 0px;
      top: 0;
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
      padding-left: 25px;

      &::before {
        display: none;
      }
    }

    &:last-child {
      border-radius: 0px 4px 4px 0px;
      padding-right: 25px;

      &::after {
        display: none;
      }
    }

    &.active {
      background-color: #5dbde7;
      color: #fff;

      &::after {
        border-left-color: #5dbde7;
      }

      &::before {
        border-top-color: #5dbde7;
        border-bottom-color: #5dbde7;
        border-left-color: #5dbde7;
      }
    }
  }
}

.cssNavEnd {
  border-radius: 0px 4px 4px 0px;
  padding-right: 25px;

  &::after {
    display: none;
  }
}

// ::v-deep.el-form-item__content {
//   display: flex;
//   width: 80%;
//   margin-left: 0px !important;
//   margin-top: 8px;
// }

.full-box {
  display: flex;
  margin-bottom: 10px;

  .el-form-item {
    width: 100%;
  }

  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;

    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
</style>
